import { render, staticRenderFns } from "./MeritList.vue?vue&type=template&id=33159de8&"
import script from "./MeritList.vue?vue&type=script&lang=js&"
export * from "./MeritList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports